/** Different values for visibility of sitemap node. */
export enum SitemapVisibility {

  /** Node is visible if it matches the roles filter. This is the default value (null). */
  Visible = "visible",
  /**
   * Node is hidden in the navigation, but can be navigated to (parent is shown as current in navi).
   * Details pages are often like: You cannot navigate into them directly from navi, only with ID.
   */
  Hidden = "hidden",

  /**
   * Page is shown as read-only if supported by the page.
   * Note that this is should not be considered as a security measure - it is for UI purposes only.
   */
  ReadOnly = "readOnly",

  /** Page is both hidden and read-only. */
  HiddenReadOnly = "hiddenReadOnly",

  /**
   * Page is disabled completely: Cannot be used in navigation.
   * Note that this is should not be considered as a security measure - it is for UI purposes only.
   */
  Disabled = "disabled",
}
